<template>
    <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog">
        <form @submit.prevent="submitForm" class="form mt-5" >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('settings.template.attach') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor"/>
                    </svg>
                </span>
              </div>
            </div>
            <div class="modal-body">
              <DropFileZone
                :id="`event_template_file_upload_${id}`"
                :files="formData.attachFiles"
                @addFiles="addFiles"
                @removeFiles="removeFiles"
                title="settings.template.add_attach"
              />
            </div>
            <div class="modal-footer">
              <Button btn-class="btn-sm" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-disabled="!formData.files.length" :is-loading="isUploading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>
  
<script setup>
  import { ref, watch} from 'vue';
  import { useStore } from "vuex";
  import {useLocales} from "@/composables/locales";
  import DropFileZone from "@/components/DropFileZone.vue";
  import Button from "@/components/Button.vue";

  const { locale } = useLocales()
  const store = useStore()
  
  const emits = defineEmits(['load'])
  const props = defineProps({
    id: String,
    templateObject: Object,
  })

  const formData = ref({
    files: [],
    attachFiles: [],
    detachFiles: []
  })

  const templateData = ref(props.templateObject)
  const isUploading = ref(false)

  watch(() => props.templateObject, (value) => {
    templateData.value = value

    if(templateData.value) {
      let data = []
      templateData.value?.files?.map(fileData => {
        let file = fileData.name.split('.')
        let type = getFileType(file[file.length-1])
        data.push({ file: fileData.name, size: fileData.size || 0, file_url: fileData.url, type: type, id: fileData.id })
      })

      formData.value.attachFiles = data
    }
  }, { immediate: true })

  function submitForm() {
    isUploading.value = true
    let fileIds = templateData.value?.files?.map(item => item.id)
    let dataIds = formData.value.files?.map(item => item.id)
    if(!(JSON.stringify(fileIds) === JSON.stringify(dataIds))){
      store.dispatch('events/saveTemplateSubject', {id: templateData.value?.template_id, subject: templateData.value?.subject, attachments: formData.value.files, detach_files: formData.value.detachFiles})
        .then(res => {
          emits('load')
          closeModal()
          formData.value.files = []
          window.toastr['success'](i18n.global.t("notification.files_uploaded"))
        })
        .catch((err) => {

        }).finally(() => {

          isUploading.value = false
        })
    }else{
      isUploading.value = false
    }
  }

  function addFiles(files){
    for(let file of files) {
        formData.value.files.push(file)
        formData.value.attachFiles.push(file)
    }
  }

  function removeFiles(index) {
      const fileToDelete = formData.value.attachFiles.splice(index, 1)
      formData.value.detachFiles?.push(fileToDelete[0]?.id)
      formData.value.files.splice(index, 1)
  }

  function getFileType(type){
    let mimeType = ''

    switch (type) {
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'doc':
        mimeType = 'application/msword';
        break;
      case 'docx':
        mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case 'jpeg':
      case 'jpg':
        mimeType = 'image/jpeg';
        break;
      case 'png':
        mimeType = 'image/png';
        break;
      default:
        mimeType = '';
    }

    return mimeType;
  }
  
  function closeModal(){
    $('#'+props.id).modal('toggle')
  }
</script>
  